import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE} from '../../../../store/search';
import {ActivityStatus, CrudStatus, SearchEntities} from '../../../../common/enums';
import {USER_MODULE_NAMESPACE} from '../../../../store/user/user-types.store';
import {IUserDetails} from '../../../../models/user';
import {BM_EDIT_PARTICIPANT_BY_FIELD, BM_MODULE_NAMESPACE} from "../../../../store/building-monitor/bm-types.store";
import {BMParticipantEditedViewModel} from "../../../../models/bm/bm-participant-edited.viewmodel";
import {IBMMeetingDetailViewModel} from "../../../../models/bm/bm-meeting-detail.viewmodel";

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component({
  components: {
  }
})
class BMParticipantModalVertical extends Vue {

  dtRules: {
    participantRules?: any
  }
  dtSearchAllContact: boolean
  dtTemporaryParticipants: any[];
  dtParticipant: any
  dtLoadingParticipant: boolean
  pmParticipant: {
    entity: SearchEntities,
    query: string,
    limit: number,
    block: number[]
  }

  constructor() {
    super();
    this.dtRules = {};
    this.dtSearchAllContact = false
    this.dtTemporaryParticipants = []
    this.dtParticipant = null
    this.dtLoadingParticipant = false
    this.pmParticipant = {
      entity: SearchEntities.Participant,
      query: '',
      limit: 1000,
      block: []
    }
  }

  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter isTenantAndOwner: boolean;
  @BMStore.Getter bmCrudActionStatus: CrudStatus
  @BMStore.Getter bmParticipantEdited: BMParticipantEditedViewModel
  @BMStore.Getter bmMeeting: { activityStatus: ActivityStatus, data: IBMMeetingDetailViewModel };

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetDeclarants: (payload: { query }) => Promise<any>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  @BMStore.Mutation(BM_EDIT_PARTICIPANT_BY_FIELD)
  storeSetBMParticipantEdited: (payload: { [key: string]: any }) => void

  @Prop({ default: false, type: [Boolean] })
  toUpdate: boolean


  get coParticipants() {
    return (this.dtTemporaryParticipants || []).filter(x => !!x)
  }

  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default,
    }
  }

  get dtSearchAll(): boolean {
    return this.dtSearchAllContact || false
  }

  set dtSearchAll(value: boolean) {
    this.dtSearchAllContact = value
  }

  get Participant(): number {
    return this.bmParticipantEdited.fk_entity
  }

  set Participant(value) {
    this.storeSetBMParticipantEdited({fk_entity: value})
  }

  get Presence(): string {
    return this.bmParticipantEdited.presence
  }

  set Presence(value) {
    this.storeSetBMParticipantEdited({presence: value})
  }

  get Summon(): boolean {
    return this.bmParticipantEdited.summon_next_meeting
  }

  set Summon(value) {
    this.storeSetBMParticipantEdited({summon_next_meeting: value})
  }

  created() {
    this.dtRules = {
      participantRules: [(v) => !!v || this.$t(this.lblSetting.bmParticipantRequired)]
    }
  }

  mounted() {
    this.$nextTick(() => {
      if (this.toUpdate) {
        delete this.pmParticipant.entity
      } else {
        this.pmParticipant.entity = SearchEntities.Participant
      }
      this.changeSwitchSearch(this.toUpdate)
    })
  }

  changeSwitchSearch (value: boolean) {
    if (value)
      delete this.pmParticipant.block
    else
      this.pmParticipant.block = [this.bmMeeting.data.master.fk_block]

    this.getParticipant()
  }

  async getParticipant(query: string = '') {
    this.pmParticipant.query = query
    this.dtLoadingParticipant = true
    return this.storeGetEntitySearch(this.pmParticipant)
      .then(res => {
        this.dtTemporaryParticipants = res
      })
      .finally(() => {
        this.dtLoadingParticipant = false
      })
  }


  handleGetDeclarants(query: string) {
    return this.getParticipant(query)
  }
  handleChangeParticipant() {}
}

export default BMParticipantModalVertical;



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-participant-modal-vertical/index.ts